import Vue from 'vue'
import App from '../../components/Login/App.vue'
import store from './store'
import router from './router'
import vuetify from '../../plugins/vuetify';
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import {HTTP} from '../../http'

Vue.config.productionTip = false

new Vue({
  HTTP,
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')